export const DETAIL_TYPE = { demographics: 1, polling: 2 };
